import { useAuth } from 'helpers/auth/auth-interceptor';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { getCurrentSupportedLanguage } from '../application/localization/localization.ts';
import { useMatomo } from '@jonkoops/matomo-tracker-react';

export const MatomoRouterTracker: React.FC = () => {
  const i18n = useTranslation();
  const currentLanguage = getCurrentSupportedLanguage(i18n.i18n);

  const location = useLocation();
  const { trackPageView: trackPageViewMatomo, pushInstruction } = useMatomo();
  const data = useAuth();
  const claims = data && data !== 'loading' ? data.claims : null;
  const userId = claims?.id ?? 'Unauthorized';
  const roles = claims?.roles ?? [];

  useEffect(() => {
    trackPageViewMatomo({
      documentTitle: document.title || location.pathname,
      // with this /, search strings are grouped under the page name
      // instead of being treated as separate pages
      href: `${location.pathname}/${location.search}`,
      customDimensions: [
        {
          id: 1,
          value: roles.join(', '),
        },
        {
          id: 2,
          value: currentLanguage,
        },
      ],
    });
    pushInstruction('setUserId', userId);
  }, [location, trackPageViewMatomo]);

  return null;
};
